import Vue from 'vue';
import App from './app';
import ElementUI from 'element-ui';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '@router';
import store from '@state/store';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import vco from 'v-click-outside';
import VueRouter from 'vue-router';
import VueFeather from 'vue-feather';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/cssfix.css';
import common from '@utils/common.js';
import vueFilter from '@utils/filters.js';
import appconfig from './app.config';

axios.interceptors.request.use(async config => {
    let token = localStorage.getItem('token'); 
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config
})

Vue.config.productionTip = true;
Vue.use(VueFeather);
Vue.use(VueAxios, axios);
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);

Vue.prototype.common = common;
Vue.prototype.appconfig = appconfig;

for (let key in vueFilter) { Vue.filter(key,vueFilter[key]) }
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');